import { createSlice } from '@reduxjs/toolkit';
import { keyBy } from 'lodash';

const initialState = {
	all: null,
};

const tagsSlice = createSlice({
	name: 'tags',
	initialState,
	reducers: {
		setTags: (state, action) => {
			if (action.payload) {
				state.all = action.payload.tags;
			}
		},
		resetTags: (state) => {
			state.all = initialState.all;
		},
	},
});

export default tagsSlice.reducer;
export const { setTags, resetTags } = tagsSlice.actions;

export const selectAllTags = (state) => state.tags.all;
export const selectTagById = (state, tagId) => state.tags.all?.[tagId];
export const selectTagsByIds = (state, tagIds) => {
	if (!tagIds) {
		return null;
	}
	const tags = tagIds.map((tagId) => state.tags.all?.[tagId]);
	return keyBy(tags, 'id');
};
